
export const initHomeCarousel = () => {
  const carousel = document.querySelector(".home-header .carousel");
  if (carousel) {
    updateHomeCarousel(carousel);
  }
  $("body").on("slid.bs.carousel", ".home-header .carousel", (e) => {
    updateHomeCarousel(e.target);
  });
}

const updateHomeCarousel = (carousel) => {
  // get active slide
  const activeSlide = carousel.querySelector(".item.active .slide-full");
  if (activeSlide && activeSlide.classList.contains("text-primary")) {
    carousel.classList.add("text-primary");
  } else {
    carousel.classList.remove("text-primary");
  }
}